module.exports = __webpack_public_path__ + "img/sld_mfm_invs_3_dark.f3abb2b1.svg";